import React from 'react';
import { useChatContext } from 'stream-chat-react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Chip from '@mui/material/Chip';
import Box from '@mui/material/Box';
import Badge from '@mui/material/Badge';
import Avatar from '@mui/material/Avatar';
import Tooltip from '@mui/material/Tooltip';

export const DirectChannelHeader = () => {
  const { client, channel } = useChatContext();
  const members = Object.values(channel.state.members).filter(({ user }) => user.id !== client.userID);
  const member = members[0];
  if (!member) return null;
  if (!channel.state.members) return null;
  return (
    <Grid container direction='row' justifyContent='flex-start' alignItems='center' spacing={0} sx={{ pl: 2, pr: 2, backgroundColor: 'white', height: 62, boxShadow: '0px 1px 0px rgba(0, 0, 0, 0.1)', overflowX: 'auto', flexWrap: 'nowrap'}}>
      <Box sx={{ width: '60px', textAlign: 'center', mr: 1}}>
        <Chip size='small' label={'Direct'} variant='outlined' color='info'/>
      </Box>
      <Tooltip title={member.user.online === true ? 'Online' : member.user.last_active ? 'Offline' : 'Never seen connected'} placement='bottom'>
      <Badge color={member.user.online === true ? 'success' : 'error'} variant='dot' overlap='circular' anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} sx={{mr: 1}}>
        <Avatar>{member.user.name.charAt(0).toUpperCase()}</Avatar>
      </Badge>
      </Tooltip>
      <Typography sx={{ minWidth: 'max-content'}} variant='h6'>{member.user.name || 'Name not found'}</Typography>
      <Box sx={{ flexGrow: 1 }}/>
    </Grid>
  );
};
